<script>
import NuevoFiltro from "./NuevoFiltro.vue";
import { mapGetters, mapActions } from "vuex";

import axios from "axios";

export default {
  components: { NuevoFiltro },
  emits: ["fetch", "clear-filter"],
  props: {
    label_filtro: String,
  },
  emits: ["fetch", "clear-filter"],
  data() {
    return {
      selectedFilter: {},
      filterOptions: [
        //NOMBRES Y VALORES DENTRO DEL SELECT
        { text: "Rango de fechas", query: "", value: "fecha" },
        {
          text: "Referencia Cliente",
          query: "",
          value: "ref_cliente",
        },
        {
          text: "Nombre Cliente",
          query: "clientes",
          value: "cliente_id",
        },
        //{text: 'Despacho',    query:'', value: 'codigo'},
        { text: "Pedidor", query: "pedidores", value: "pedidor" },
        {
          text: "Garantías y Correcciones",
          query: "",
          value: "administrativas",
        },
        { text: "Revisor", query: "revisores", value: "revisor" },
        {
          text: "Agentes Carga",
          query: "agentes_carga",
          value: "agentes_carga",
        },
        {
          text: "Caracteristicas Carga",
          query: "caracteristicas_carga",
          value: "caracteristicas_carga",
        },
        {
          text: "Estados de Despacho",
          query: "estados_despacho",
          value: "estados_despacho",
        },
        {
          text: "Estados Retiro",
          query: "estados_retiro",
          value: "estados_retiro",
        },
        { text: "Gestores", query: "gestores", value: "gestores" },
        {
          text: "Jefes de Operaciones",
          query: "jefes_operaciones",
          value: "jefes_operaciones",
        },
        {
          text: "Nombres de Transporte",
          query: "nombres_transporte",
          value: "nombres_transporte",
        },
        { text: "Nombre de nave", query: "", value: "nombre_nave" },
        { text: "Tipos Carga", query: "tipos_carga", value: "tipos_carga" },
        {
          text: "Tipos Condicion",
          query: "tipos_condicion",
          value: "tipos_condicion",
        },
        {
          text: "Tramitadores Aduaneros",
          query: "tramitadores_aduaneros",
          value: "tramitadores_aduaneros",
        },
        { text: "Aduana", query: "aduanas", value: "aduana" },
        { text: "Aforo", query: "aforo", value: "aforo" },
        {
          text: "Número de Manifiesto",
          query: "",
          value: "numero_manifiesto",
        },
        {
          text: "Número de Documento de Transporte",
          query: "",
          value: "numero_documento_transporte",
        },
      ],

      selectedFilters: [],
    };
  },
  computed: {
    ...mapGetters({
      filtro: "filtros/filtro",
      fecha: "filtros/fecha",
    }),
  },

  methods: {
    async addFilter() {
      const exists = this.selectedFilters.some(
        (filter) => this.selectedFilter.value == filter.type
      );
      if (!exists && this.selectedFilter?.value) {
        if (this.selectedFilter.value == "fecha") {
          this.selectedFilters.push({
            id: this.id,
            query: "",
            type: "fecha",
            text: this.selectedFilter.text,
            fecha: ["", ""],
          });
        } else {
          this.selectedFilters.push({
            id: this.id,
            type: this.selectedFilter.value,
            query: this.selectedFilter.query,
            text: this.selectedFilter.text,
            value: "",
          });
        }
      }
    },

    remove(type) {
      this.selectedFilters = this.selectedFilters.filter(
        (filter) => filter.type != type
      );
      if (this.selectedFilters.length == 0) this.clearFilter();
      else this.submit(this.selectedFilters);
    },

    clearFilter() {
      this.selectedFilters = [];
      this.$emit("clear-filter");
    },

    ///CHANGE
    changeDate(type, value) {
      const selected = this.selectedFilters?.find(
        (filter) => filter.type == "fecha"
      );

      if (selected && selected.fecha) {
        if (type == "inicio") this.$set(selected.fecha, 0, value);
        if (type == "final") this.$set(selected.fecha, 1, value);
      }
    },

    changeValue(type, value) {
      const selected = this.selectedFilters?.find(
        (filter) => filter.type == type
      );
      selected.value = value;
    },
  },
};
</script>

<template>
  <div class="flex flex-col gap-4 text-left">


    <div class="flex flex-col gap-4">
      <div class="flex flex-col w-full">
        <label class="text-left">Agregar filtro</label>
        <select v-model="selectedFilter">
          <option
            v-for="option in filterOptions"
            :key="option.value"
            :value="option"
          >
            {{ option.text }}
          </option>
        </select>
      </div>

      <button
        class="ml-auto btn-principal"
        type="button"
        @click="() => addFilter()"
      >
        Agregar filtro
      </button>
    </div>

    <div
      :key="selectedFilter.id"
      v-for="selectedFilter in selectedFilters"
      class="grid grid-cols-1 gap-8 w-full"
    >
      <nuevo-filtro
        class="xl:col-end-3 col-span-2 xl:col-span-1 w-full"
        :selectedFilter="selectedFilter"
        :filterTypes="filterOptions"
        @remove="(type) => remove(type)"
        @change-date="(type, value) => changeDate(type, value)"
        @change-value="(type, value) => changeValue(type, value)"
      >
      </nuevo-filtro>
    </div>

    <div class="flex flex-row justify-end gap-4 w-full">
      <button
        v-if="selectedFilters.length > 0"
        type="button"
        class="btn-principal"
        @click="() => $emit('fetch', selectedFilters)"
      >
        Filtrar
      </button>
      <button
        v-if="selectedFilters.length > 0 || filtro.estado == true"
        type="button"
        @click="clearFilter"
        class="btn-secundario"
      >
        Limpiar
      </button>
    </div>
  </div>
</template>
